import { useCallback, useEffect, useState } from 'react';
import { posVendaApi, type EntitlementPosVenda } from '@/features/pos-venda/api/posVendaApi';

type Estado = {
  entitlement: EntitlementPosVenda | null;
  carregando: boolean;
  erro: string | null;
};

/**
 * Verifica no servidor se a conta tem pós-venda ativo. Usado para o
 * cadeado do menu e para liberar a tela. `recarregar(true)` força uma
 * verificação sem cache (ex.: depois que o admin liberou).
 */
export function usePosVendaEntitlement() {
  const [estado, setEstado] = useState<Estado>({
    entitlement: null,
    carregando: true,
    erro: null,
  });

  const recarregar = useCallback((forcar = false) => {
    setEstado((s) => ({ ...s, carregando: true, erro: null }));
    return posVendaApi.entitlement(forcar).then(
      (entitlement) => setEstado({ entitlement, carregando: false, erro: null }),
      (e: unknown) => {
        const mensagem = e instanceof Error ? e.message : 'Falha ao verificar pós-venda.';
        setEstado({ entitlement: null, carregando: false, erro: mensagem });
      },
    );
  }, []);

  useEffect(() => {
    void recarregar();
  }, [recarregar]);

  const ativo = estado.entitlement?.ativo ?? false;
  return { ...estado, ativo, recarregar };
}
